module.exports = __webpack_public_path__ + "static/media/avance_ja_white.2226c452.svg";